import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ElementRef,
  TemplateRef,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { causeEffectModelElement } from 'src/app/models/analytical-toolsModels/cause-effectmodel';
import { AnalyticalToolsService } from 'src/app/services/analytical-tools.service';
import { AtHeader } from 'src/app/models/analytical-toolsModels/atHeader';
import { MatCheckbox } from '@angular/material/checkbox';
import { FivewhyService } from 'src/app/services/fivewhy.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { ManagerExecutionService } from '../../services/manager.service';
import { MatDialog } from '@angular/material/dialog';
import { ImageDialogComponent } from 'src/app/analytical-tools/image-dialog/image-dialog.component';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { CommonService } from 'src/app/services/common.service';
import * as moment from 'moment';
import { differenceInCalendarDays, setHours } from 'date-fns';
import { Observable, ReplaySubject, Subject, Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { BaseApi } from 'src/backend/api/base-api';
import { EmployeeService } from 'src/backend/services/user-access-services/employee.service';
import { Employee } from 'src/backend/models/user/employee';
import { FormControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { OverallActionPlanService } from 'src/app/services/overall-actionPlan.service';
import { FileUploadService } from 'src/app/services/upload-file.service';
import { UserService } from 'src/backend/services/user-access-services/user.service';
import { WorkFlowService } from 'src/app/services/work-flow.service';

@Component({
  selector: 'app-fivewhy-actionplan',
  templateUrl: './fivewhy-actionplan.component.html',
  styleUrls: ['./fivewhy-actionplan.component.scss'],
})
export class FivewhyActionplanComponent implements OnInit, OnDestroy {
  private readonly legacyEmptyAttachmentPlaceholder = 'filename';
  @Input() destroy$: Subject<void>;
  newGroupItemParent!: causeEffectModelElement;
  @Output() onSuccess: EventEmitter<any> = new EventEmitter();
  @Output() _emitHeaderData: EventEmitter<any> = new EventEmitter();
  isAnyFileUploaded: boolean;
  @Output() saveNCRFilesEvent = new EventEmitter<any>();
  @Output() getAtfilesEvent = new EventEmitter<any>();
  callSaveMethod: boolean = false;
  files: File[];
  @Input('data')
  set data(data: any) {
    //do whatever you want with your data here, this data will be passed from parent component
    console.log(data);
  }
  @Input() headerID: any;
  @Input() _permission: any;
  public filteredemployee: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public valueSearchCtrl: FormControl = new FormControl();
  causeEffect: any = [];
  stageName: string = '5 Why Action Plan';
  stageId: number = 5;
  breadcrumList!: any;
  spinnerText: string = '';
  headerData: any = {
    ID: 0,
    Group: '',
    Plant: '',
    Dept: '',
    Team: '',
    TeamLeader: '',
    InitProbStatement: '',
    NoOfM: 6,
    stageId: 5,
    uniqueCode: '',
    CreatedAt: new Date(),
    CreatedBy: '',
  };
  user: any;
  rcaId: number = 0;
  updateStatus: boolean = false;
  hasCompletedActions: boolean = false;
  CriticalityLevels = [
    { name: 'High', value: 3 },
    { name: 'Medium', value: 2 },
    { name: 'Low', value: 1 },
  ];
  blobStorageUrl = Constants.BLOB_STORAGE_URL;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatCheckbox) checkbox!: MatCheckbox;

  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('fileInputFile') fileInputFile!: ElementRef;
  @Input() actionPlan_: EventEmitter<any> = new EventEmitter();
  @Input() headerData_: EventEmitter<any> = new EventEmitter();
  imageFile: any;
  imageSrc: any;
  ImageUrl: any;
  @ViewChild('imageZoomModel') private imageZoomModel!: TemplateRef<any>;

  // causeEffectModelColumns: string[] = ['RootCause', 'Action', 'ActionType', 'Picture', 'File', 'AssignTo', 'AssignedDate', 'TargetDate', 'RevisedDate', 'No Of Misses', 'ActionCompleted (Yes/No)', 'ActionCompleted (By & On)', 'Verification (Approved / Disapproved)', 'Verification (By & On)', 'New Assignee', 'ClosedDate', 'Remarks', 'Verified', 'VerifiedBy', 'Status', '', ''];

  causeEffectModelColumns: string[];

  fiveWhy: any = [];
  fiveWhyActionPlan: any = [];
  userList: any = [];
  filteredUserList: any = [];
  filteredVerifyUserList: any = [];

  fiveWhyActionPlanDataSource = new MatTableDataSource();
  formData: any = [];
  levelId: number = 5;
  isReset: boolean = false;
  FileList: any = [];
  FileData: any = [];
  ind: any = 0;
  UploadFile: any = [];
  IndividualFivewhyID: number = 0;
  permisson!: any;
  IsWrite: boolean = false;
  IsAccess!: any;
  orgfiveWhy: any = [];
  userAllList: any = [];
  newUserList: any = [];
  newUserFiltList: any = [];
  newOrgUserList: any = [];
  newOrgUserFiltList: any = [];
  sub: Subscription;
  cycleStatuses: any;
  teamList: any = [];
  teamListTemp: any = [];
  employees: Employee[] = [];
  employeesTemp: Employee[] = [];
  mClassificationTypes: any[] = [];
  transitions: any[] = [];
  ncrWorkFlow: any;
  plantData:any;
  constructor(
    public managerExecutionService: ManagerExecutionService,
    private FivewhyService: FivewhyService,
    private domSanitizer: DomSanitizer,
    private fileUploadService: FileUploadService,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    public router: Router,
    private analyticalToolsService: AnalyticalToolsService,
    private route: ActivatedRoute,
    private userManagementService: UserManagementService,
    private dialog: MatDialog,
    private enterpriseGroupService: EnterPriseGroupService,
    private commonService: CommonService,
    private dataService: DataService,
    private baseApi: BaseApi,
    private employeeService: EmployeeService,
    private actionplanService: OverallActionPlanService,

    private userService: UserService,
    private flowService: WorkFlowService,
    public translate: TranslateService
  ) {}

  replaceIcon(value: any): any {
    return value.replace(/(<([^>]+)>)/gi, '');
  }

  private normalizeAttachmentValue(value: any): any {
    return value === this.legacyEmptyAttachmentPlaceholder || value === ''
      ? null
      : value;
  }

  ngOnInit(): void {
    this.getMClassificationList();
    this.plantData = this.baseApi.getPlantFromStorage();
    this.getWorkFlowTransitions();
    this.sub = this.actionPlan_.pipe(takeUntil(this.destroy$)).subscribe((event: any) => {
      console.log(event);
      this.saveFiveWhyPlan(event);
    });
    window.scrollTo(0, 0);
    this.getAllUserList();
    this.dataService.getData().pipe(takeUntil(this.destroy$)).subscribe((value: any) => {
      this.headerData = value;
      console.log(value);
    });

    this.permisson = this._permission;
    this.IsWrite = this.permisson?.IsWrite;
    //this.GetBreadcrumList();
    this.getEmployeesByPlant();
    //this.GetMenuAccess();
    this.user = this.baseApi.getUserSession();
    this.headerData.CreatedBy = this.user.userCode;
    const userGroup = this.analyticalToolsService.getUserGroup();
    if (userGroup) this.headerData.Group = userGroup;
    this.fiveWhyActionPlanDataSource = new MatTableDataSource(this.fiveWhy);
    //this.getMClassificationList();
    this.headerData.ID = this.headerID;
    this.valueSearchCtrl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.filterValue();
      });
  }
  createColumns() {
    let columns = [
      'Root Cause',
      'Action',
      'Criticality Level',
      'M Classification',
      'Action Type',
      'Picture (jpg,png,jpeg)',
      'File (pdf,doc)',
      'Assign To',
      'Assigned Date',
      'Target Date',
      'Revised Date',
      'No Of Misses',
      'Action Completed (Yes/No)',
      'Action Completed (By & On)',
      'Verification (Approved / Disapproved)',
      'Verified (By & On)',
      'New Assignee',
      'Closed Date',
      'Remarks',
      'Status',
      'Actions',
    ];
    let route: any = this.router.url;
    route = route.split('/');
    route = route.pop();
    const limitedColumns = ['MeetingMatrixV2', 'Scorecard', 'MeetingMatrix'];
    if (limitedColumns.includes(route)) {
      console.log(this.cycleStatuses);
      // if (this.cycleStatuses.StatusCycle === 'InProgress') {
      //   this.causeEffectModelColumns = columns;
      // } else
      if (this.cycleStatuses.StatusCycle === 'Completed') {
        this.causeEffectModelColumns = columns;
      } else {
        this.causeEffectModelColumns = [
          'Root Cause',
          'Action',
          'Criticality Level',
          'Action Type',
          'Picture (jpg,png,jpeg)',
          'File (pdf,doc)',
          'Assign To',
          'Target Date',
          'Actions',
        ];
      }
    } else {
      this.causeEffectModelColumns = columns;
    }

    console.log(this.causeEffectModelColumns);
  }

  showRemainingColumns() {
    let route: any = this.router.url;
    route = route.split('/');
    route = route.pop();
    const limitedColumns = ['MeetingMatrixV2', 'Scorecard', 'MeetingMatrix'];
    if (limitedColumns.includes(route)) {
      // if (this.cycleStatuses.StatusCycle === 'InProgress') {
      //   return true;
      // }
      return false;
    } else {
      return true;
    }
  }
  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    this.spinnerText = 'Loading Menu Data';
    // this.spinner.show();
    this.userManagementService.GetBreadcrumList(obj).pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        // this.spinner.hide();
        this.breadcrumList = data.BreadcrumList;
        console.log(data.BreadcrumList);
      },
      (error) => {
        // this.spinner.hide();
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.enterpriseGroupService.GetMenuAccess(key).pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        this.permisson = data;
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  getFiveWhyActionPlan(reset: any): any {
    this.spinnerText = 'Fetching Five Why Plan Data';
    this.spinner.show();
    const data = { headerId: this.analyticalToolsService.getHeaderId() || 0 };
    this.FivewhyService.getFiveWhyPlanData(data).pipe(takeUntil(this.destroy$)).subscribe(
      (res: any) => {
        console.log(res);
        this.spinner.hide();
        this.updateStatus = res.updateStatus;
        this.levelId = res && res.stageId ? res.stageId : 0;
        this.analyticalToolsService.setTeamLeaderList(res.Team);
        this.rcaId = res.rcaId ? res.rcaId : 0;

        delete res.rcaId;

        if (res.ID) {
          this.headerData = res;
        } else console.log(this.headerData);
        // ---------------  new changes  -------------------
        if (this.headerID !== 0) {
          this.getAtfilesEvent.emit();
        }
        if (this.callSaveMethod == true) {
          this.saveNCRFilesEvent.emit();
          const files = this.fileUploadService.getFiles();
          if (files.length > 0) {
            this.fileUploadService.saveNCRFiles(this.headerData.ID);
          } else {
            console.error('No files available for saving.');
          }
        }
        // ---------------  new changes  -------------------
        // this.analyticalToolsService.setHeaderId(this.headerData.ID);
        this.analyticalToolsService.setRcaId(this.rcaId);
        this.analyticalToolsService.setLevelId(this.levelId);
        this.analyticalToolsService.setStatus(this.updateStatus);

        this.cycleStatuses = res;
        if (res.fiveWhyActionPlan?.length) {
          this.fiveWhy = res.fiveWhy;
          this.fiveWhyActionPlan = res.fiveWhyActionPlan.map((action) => {
            // Add hasCompletedActions property - true only for existing completed records
            action.hasCompletedActions = Boolean(action.ID && action.ActionCompleted === 'Yes');
            
            // Track original status and verification for detection of changes
            action.originalStatus = action.Status;
            action.UploadDoc = this.normalizeAttachmentValue(action?.UploadDoc);
            action.FileName = this.normalizeAttachmentValue(action?.FileName);
            action.UploadFile = this.normalizeAttachmentValue(action?.UploadFile);
            action.hasClosedActions = Boolean(action.ID && action.Status === 'Closed');
            action.originalVerification = action.Verification;
            action.hasRejectedActions = Boolean(action.ID && action.Verification === 'Rejected');
            action.originalNewAssignee = action.NewAssignee;
            action.hasNewAssigneeAdded = Boolean(action.ID && action.NewAssignee);
            action.Verification = action.Verification ?? '';

            if (action.MClassification === null && action.fiveWhyId) {
              const matchingFiveWhy = this.fiveWhy.find(
                (f) => f.ID === action.fiveWhyId
              );
              if (matchingFiveWhy && matchingFiveWhy.TypeOfM) {
                action.MClassification = +matchingFiveWhy.TypeOfM; // force into int
              }
            } else if (action.MClassification) {
              action.MClassification = +action.MClassification; // convert if not null
            }
            return action;
          });

          console.log('this.fiveWhyActionPlan', this.fiveWhyActionPlan);

          // Use the processed fiveWhyActionPlan with tracking properties, not the raw data
          this.fiveWhy = this.fiveWhyActionPlan;
          console.log('this.fiveWhy', this.fiveWhy);
        } else {
          //this.createFiveWhy();
        }

        this.createColumns();
        if (this.levelId != 0 && this.levelId != 5) {
          if (this.fiveWhy && this.fiveWhy.length) {
            const actionplan = this.fiveWhy.filter(
              (fiveY: any) => fiveY.RootCause != ''
            );
            this.fiveWhy = actionplan && actionplan.length ? actionplan : [];
            this.orgfiveWhy = this.fiveWhy;
          }
          if (this.IndividualFivewhyID) {
            const actionplan = this.fiveWhy.filter(
              (fiveY: any) => fiveY.fiveWhyId == this.IndividualFivewhyID
            );
            this.fiveWhy = actionplan && actionplan.length ? actionplan : [];
          }
        } else {
          if (this.fiveWhy && this.fiveWhy.length == 1) {
            this.fiveWhy[0].MainRowShow = true;
          }
          this.orgfiveWhy = this.fiveWhy;
        }

        if (this.levelId == 0 || this.levelId == 5) {
          if (this.fiveWhy && this.fiveWhy.length && this.fiveWhy.length > 1) {
            this.setFyActionSort();
          }
        }

        for (const fya of this.fiveWhy) {
          fya['base64'] = '';
          const mRecords = this.fiveWhy.filter(
            (fiveY: any) => fya.fiveWhyId == fiveY.fiveWhyId
          );
          // if (mRecords && mRecords.length) {
          //   let disabled = mRecords.map((rec: any, index: number) => {
          //     if (index == 0)
          //       rec.rowSpan = mRecords && mRecords.length ? mRecords.length : 1;
          //     else {
          //       rec.spanRow = true;
          //     }
          //   });
          // }
          fya.PriorityLevel = fya.PriorityLevel ? fya.PriorityLevel : 1;
          fya.NoOfMisses = fya.NoOfMisses ? fya.NoOfMisses : 0;
          fya.MissesCondition = true;

          if (fya.Status == 'InProgress') {
            let currentDate: any = new Date();
            let targetDate: any = new Date(fya.TargetDate);
            currentDate = moment(currentDate).format('YYYY-MM-DD');
            targetDate = moment(targetDate).format('YYYY-MM-DD');
            if (currentDate > targetDate) {
              fya.Status = 'Delayed';
              fya.NoOfMisses = 1;
            }
          }
          fya.ActionCompleted = fya.ActionCompleted == 'Yes' ? 'Yes' : 'No';
        }

        // let a = this.fiveWhy.filter((obj: any) => !obj.spanRow);
        // if (a && a.length) {
        //   for (let index = 0; index < a.length; index++) {
        //     if (index == a.length - 1) a[index].MainRowShow = true;
        //     else a[index].MainRowShow = false;
        //   }
        // }

        if (reset == 'reset' && !this.headerData.ID) this.resetData();
        setTimeout(() => {
          this.getUserList();
        }, 1500);

        // Update assignment flags for all rows after data is loaded
        this.updateAllRowsAssignmentFlags();

        this.fiveWhyActionPlanDataSource = new MatTableDataSource(this.fiveWhy);
      },
      (error) => {
        this.spinner.hide();
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  getUserList() {
    this.spinnerText = 'Fetching User Data';
    this.spinner.show();
    console.log(this.headerData);
    // this.headerData = this._headerData;
    const data = {
      EGId: this.headerData?.group || this.headerData?.Group,
      PlantId: this.headerData?.plant || this.headerData?.Plant,
    };

    this.commonService.getPeopleMasterData(data).pipe(takeUntil(this.destroy$)).subscribe(
      (res: any) => {
        console.log(res);
        if (!res.HasError) {
          // this.orgMachineryList.map((machinery: any) => this.machineryList.push([...this.mList.machineryList]));
          this.userList = res.employeeInfoList;
          this.userList.map(
            (user: any) =>
              (user.FullName =
                user.FirstName.trim() + ' ' + user.lastName.trim())
          );

          this.filteredUserList = this.userList.slice();
          this.filteredVerifyUserList = this.userList.slice();

          this.fiveWhy.map((orgUser: any) =>
            this.newUserList.push([...this.userList])
          );
          this.fiveWhy.map((orgUser: any) =>
            this.newOrgUserList.push([...this.userList])
          );
          this.newUserFiltList =
            this.newUserList && this.newUserList.length
              ? this.newUserList.slice()
              : [];
          this.newOrgUserFiltList =
            this.newOrgUserList && this.newOrgUserList.length
              ? this.newOrgUserList.slice()
              : [];
          console.log(this.newUserFiltList);
        }
        this.spinner.hide();
      },
      (err: any) => {
        console.log(err);
        this.spinner.hide();
      }
    );
  }

  searchValues(filter: any, index: number, type: any) {
    filter = filter.target.value;
    if (type == 'assignTo') {
      this.newUserList[index] = this.userList.filter((user: any) => {
        let lowerCase = user.fullName.toLocaleLowerCase();
        return user.fullName.startsWith(filter) || lowerCase.startsWith(filter);
      });
    } else if (type == 'newAssignee') {
      this.newOrgUserList[index] = this.userList.filter((user: any) => {
        let lowerCase = user.fullName.toLocaleLowerCase();
        return user.fullName.startsWith(filter) || lowerCase.startsWith(filter);
      });
    }
  }

  getEmployeesByPlant() {
    this.spinner.show();
    this.employeeService.getAllEmployees().pipe(takeUntil(this.destroy$)).subscribe(
      (res: any) => {
        this.employees = res;
        this.employeesTemp = this.employees.slice();
        this.filteredemployee.next(this.employeesTemp);
        this.getFiveWhyActionPlan('');
        this.spinner.hide();
      },
      (err: any) => {
        this.spinner.hide();
      }
    );
  }
  filterValue(): void {
    if (!this.employeesTemp) {
      return;
    }
    let search = this.valueSearchCtrl.value;
    if (!search) {
      this.filteredemployee.next(this.employeesTemp);
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredemployee.next(
      this.employeesTemp.filter(
        (value: any) => value.fullName.toLowerCase().indexOf(search) > -1
      )
    );
  }

  getAllUserList() {
    // this.spinnerText = "Fetching User Data";
    this.spinner.show();
    this.userService.getUsersByPlant().pipe(takeUntil(this.destroy$)).subscribe(
      (res: any) => {
        this.userAllList = res;
        this.spinner.hide();
        // this.getFiveWhyActionPlan('');
      },
      (err: any) => {
        console.log(err);
        this.spinner.hide();
      }
    );
  }

  setSort() {
    this.fiveWhy.sort(function (a: any, b: any) {
      return a.fiveWhyId - b.fiveWhyId;
    });
  }

  setFyActionSort() {
    let i = 1;
    for (const fya of this.fiveWhy) {
      let arr = this.fiveWhy.filter(
        (fiveY: any) => fiveY.FyActionId == fya.FyActionId
      );
      if (arr && arr.length && !fya.fiveWhyId) {
        arr.map((cause: any, index: number) => {
          cause.fiveWhyId = i;
        });
        i++;
      }
    }
    this.fiveWhy.map((cause: any, index: number) => {
      delete cause.FyActionId;
    });
  }

  addRow(element: any, i: number, type: any) {
    let obj: any;
    if (type == 'sub') {
      obj = {
        fiveWhyId: element.fiveWhyId,
        RootCause: element.RootCause,
        Action: '',
        PriorityLevel: element.PriorityLevel,
        MClassification: element.MClassification,
        ActionType: element.ActionType,
        AssignTo: '',
        NewAssignee: '',
        AssignedDate: null,
        TargetDate: null,
        RevisedDate: null,
        NoOfMisses: 0,
        ActionCompleted: 'No',
        ActionCompletedBy: '',
        ActionCompletedOn: null,
        Verification: '',
        VerificationBy: '',
        VerificationOn: null,
        ClosedDate: null,
        Status: 'Open',
        VerifiedBy: '',
        FromActionPlan: true,
        // Initialize tracking properties for new actions
        hasCompletedActions: false,
        hasClosedActions: false,
        hasRejectedActions: false,
        hasNewAssigneeAdded: false,
        originalStatus: 'Open',
        originalVerification: '',
        originalNewAssignee: '',
        isNewlyCompleted: false,
        isNewlyClosed: false,
        isNewlyRejected: false,
        isNewlyReassigned: false
      };
      obj.MainRowShow = false;
    } else if (type == 'main') {
      obj = {
        fiveWhyId: element.fiveWhyId,
        fiveWhy: element.fiveWhy,
        RootCause: '',
        Action: '',
        isNewRow: true,
        PriorityLevel: element.PriorityLevel,
        MClassification: '',
        ActionType: element.ActionType,
        AssignTo: '',
        NewAssignee: '',
        AssignedDate: null,
        TargetDate: null,
        RevisedDate: null,
        NoOfMisses: 0,
        ActionCompleted: 'No',
        ActionCompletedBy: '',
        ActionCompletedOn: null,
        Verification: '',
        VerificationBy: '',
        VerificationOn: null,
        ClosedDate: null,
        Status: 'Open',
        VerifiedBy: '',
        FromActionPlan: true,
        // Initialize tracking properties for new actions
        hasCompletedActions: false,
        hasClosedActions: false,
        hasRejectedActions: false,
        hasNewAssigneeAdded: false,
        originalStatus: 'Open',
        originalVerification: '',
        originalNewAssignee: '',
        isNewlyCompleted: false,
        isNewlyClosed: false,
        isNewlyRejected: false,
        isNewlyReassigned: false
      };
    }
    // this.fiveWhy.push({ Action: element.Action, ActionType: element.ActionType, AssignTo: element.AssignTo, TargetDate: element.TargetDate, RevisedDate: element.RevisedDate, ClosedDate: element.ClosedDate, Status: element.Status, VerifiedBy: element.VerifiedBy, FromActionPlan:true});
    this.fiveWhy.splice(i + 1, 0, obj);
    console.log(obj, 'bingo');
    this.setSort();

    // for (const fya of this.fiveWhy) {
    //   const mRecords = this.fiveWhy.filter(
    //     (fiveY: any) => fya.fiveWhyId == fiveY.fiveWhyId
    //   );
    //   if (mRecords && mRecords.length) {
    //     let disabled = mRecords.map((rec: any, index: number) => {
    //       if (index == 0)
    //         rec.rowSpan = mRecords && mRecords.length ? mRecords.length : 1;
    //       else {
    //         rec.spanRow = true;
    //       }
    //     });
    //   }
    // }
    let a = this.fiveWhy.filter((obj: any) => !obj.spanRow);
    if (a && a.length) {
      for (let index = 0; index < a.length; index++) {
        if (index == a.length - 1) a[index].MainRowShow = true;
        else a[index].MainRowShow = false;
      }
    }
    this.newUserList = [];
    this.newOrgUserList = [];
    this.fiveWhy.map((orgUser: any) =>
      this.newUserList.push([...this.userList])
    );
    this.fiveWhy.map((orgUser: any) =>
      this.newOrgUserList.push([...this.userList])
    );
    this.newUserFiltList =
      this.newUserList && this.newUserList.length
        ? this.newUserList.slice()
        : [];
    this.newOrgUserFiltList =
      this.newOrgUserList && this.newOrgUserList.length
        ? this.newOrgUserList.slice()
        : [];
    this.fiveWhyActionPlanDataSource = new MatTableDataSource(this.fiveWhy);
  }
  deleteRow(i: any) {
    if (this.levelId == 0 || this.levelId == 5) {
      const isHaveSub = this.fiveWhy.filter(
        (cause: any) => cause.fiveWhyId == this.fiveWhy[i].fiveWhyId
      );
      // if (isHaveSub && isHaveSub.length > 1 && !this.fiveWhy[i].spanRow) {
      //   this.toaster.warning('Warning', `Remove sub row for this row`);
      //   return;
      // }
    }
    this.fiveWhy.splice(i, 1);
    for (const fya of this.fiveWhy) {
      const mRecords = this.fiveWhy.filter(
        (fiveY: any) => fya.fiveWhyId == fiveY.fiveWhyId
      );
      // if (mRecords && mRecords.length) {
      //   let disabled = mRecords.map((rec: any, index: number) => {
      //     if (index == 0)
      //       rec.rowSpan = mRecords && mRecords.length ? mRecords.length : 1;
      //     else {
      //       rec.spanRow = true;
      //     }
      //   });
      // }
    }
    let b = this.fiveWhy.filter((obj: any) => !obj.spanRow);
    if (b && b.length) {
      for (let index = 0; index < b.length; index++) {
        if (index == b.length - 1) b[index].MainRowShow = true;
        else b[index].MainRowShow = false;
      }
    }
    this.newUserList = [];
    this.newOrgUserList = [];
    this.fiveWhy.map((orgUser: any) =>
      this.newUserList.push([...this.userList])
    );
    this.fiveWhy.map((orgUser: any) =>
      this.newOrgUserList.push([...this.userList])
    );
    this.newUserFiltList =
      this.newUserList && this.newUserList.length
        ? this.newUserList.slice()
        : [];
    this.newOrgUserFiltList =
      this.newOrgUserList && this.newOrgUserList.length
        ? this.newOrgUserList.slice()
        : [];
    this.fiveWhyActionPlanDataSource = new MatTableDataSource(this.fiveWhy);
  }

  isChecked(event: any, row: any) {
    if (event.checked) {
      row.VerifiedBy = this.user.userCode;
    } else {
      row.VerifiedBy = null;
    }
  }

  getUserName(row: any, type: any) {
    if (type == 'actionBy') {
      let objFindName = this.userAllList.find(
        (usr: any) => usr.userCode == row.ActionCompletedBy
      );
      if (objFindName) return objFindName.fullName;
      else if (row.ActionCompletedBy == 100001) return 'Admin';
      else return null;
    } else if (type == 'verificationBy') {
      let objFindName = this.userAllList.find(
        (usr: any) => usr.userCode == row.VerificationBy
      );
      if (objFindName) return objFindName.fullName;
      else if (row.VerificationBy == 100001) return 'Admin';
      else return null;
    } else if (type == 'verifiedBy') {
      let objFindName = this.userAllList.find(
        (usr: any) => usr.userCode == row.VerifiedBy
      );
      if (objFindName) return objFindName.fullName;
      else if (row.VerifiedBy == 100001) return 'Admin';
      else return null;
    }
  }

  getFileTypeName(val: any) {
    if (val && typeof val === 'string') {
      let arr = val.split('.');
      if (arr && arr.length && arr.length != 1)
        return `( ${arr[arr.length - 1]} )`;
      // else if (arr.length == 1) {
      //   arr = val.split(';');
      //   arr = arr[0].split('/');
      //   return `( ${arr[arr.length - 1]} )`;
      // }
      else return ``;
    }
  }

  resetData() {
    console.log('truggered');
    this.headerData = {
      ID: 0,
      Group: '',
      Plant: '',
      Dept: '',
      Team: '',
      TeamLeader: '',
      InitProbStatement: '',
      NoOfM: 6,
      stageId: 5,
      uniqueCode: '',
      CreatedAt: new Date(),
      CreatedBy: this.user.userCode,
    };
    this.isReset = true;
    this.analyticalToolsService.setRca(false);
    this.analyticalToolsService.setRcaId(0);
    this.analyticalToolsService.setHeaderId(0);
    this.analyticalToolsService.setFilteredIndex(0);
    this.analyticalToolsService.setFilteredData([]);
    this.analyticalToolsService.setTeamLeaderList([]);
    this.getFiveWhyActionPlan('');
  }

  saveFiveWhyPlan(e: any) {
    let event = e.headerData;
    let integrationData = e.integrationData;
    let statusCheck = false;
    delete event?.stageID;
    delete event?.CauseFileCount;

    // const checkRemark = this.fiveWhy.find(
    //   (el: any) => el.RevisedDate && !el.Remarks
    // );
    // if (checkRemark) {
    //   this.toaster.warning(
    //     'Warning',
    //     `Please Fill The Remarks Field For Rootcause ${checkRemark.RootCause}`
    //   );
    //   return;
    // }

    // Check for mandatory remarks when verification is disapproved
    const checkDisapprovedRemark = this.fiveWhy.find(
      (el: any) => el.Verification === 'Disapproved' && (!el.Remarks || el.Remarks.trim() === '')
    );
    if (checkDisapprovedRemark) {
      this.toaster.warning(
        'Warning',
        `Please Fill The Remarks Field For Rootcause ${checkDisapprovedRemark.RootCause}`
      );
      return;
    }
    // Track newly completed, newly closed, newly rejected, and newly added assignee actions for notifications
    const newlyCompletedActions: any[] = [];
    const newlyClosedActions: any[] = [];
    const newlyRejectedActions: any[] = [];
    const newlyAddedAssigneeActions: any[] = [];
    
    for (const fiveWhy of this.fiveWhy) {
      // if (fiveWhy.RevisedDate && !fiveWhy.Remarks) {
      //   this.toaster.warning('Warning', `Please Fill The Remarks Field For Rootcause ${fiveWhy.RootCause}`);
      //   return;
      // }
      delete fiveWhy.FileSrc;
      delete fiveWhy.DocSrc;
      delete fiveWhy.minRevisedDate;
      delete fiveWhy.MinTargetDate;
      delete fiveWhy.rowSpan;
      delete fiveWhy.spanRow;
      
      // Check if this action is newly completed (not completed before but completed now)
      const isNewlyCompleted = fiveWhy.ActionCompleted === 'Yes' && !fiveWhy.hasCompletedActions;
      if (isNewlyCompleted) {
        newlyCompletedActions.push(fiveWhy);
      }
      
      // Check if this action is newly closed (not closed before but closed now)
      // This covers both manual closure and approval-based closure
      const isNewlyClosed = fiveWhy.Status === 'Closed' && !fiveWhy.hasClosedActions;
      if (isNewlyClosed) {
        newlyClosedActions.push(fiveWhy);
      }
      
      // Check if this action is newly rejected (not rejected before but rejected now)
      const isNewlyRejected = fiveWhy.Verification === 'Rejected' && !fiveWhy.hasRejectedActions;
      if (isNewlyRejected) {
        newlyRejectedActions.push(fiveWhy);
      }
      
      // Check if new assignee was added/changed
      // Case 1: First time assignment (newly added newassignee)
      const isNewAssigneeFirstTime = fiveWhy.ID && // Must have ID (existing action)
                                   fiveWhy.NewAssignee && 
                                   !fiveWhy.originalNewAssignee && // No previous value (first time assignment)
                                   fiveWhy.NewAssignee !== fiveWhy.AssignTo;
      
      // Case 2: Changed assignment (existing newassignee changed to different person)
      const isNewAssigneeChanged = fiveWhy.ID && // Must have ID (existing action)
                                 fiveWhy.NewAssignee && 
                                 fiveWhy.originalNewAssignee && // Must have had a previous value
                                 fiveWhy.NewAssignee !== fiveWhy.originalNewAssignee &&
                                 fiveWhy.NewAssignee !== fiveWhy.AssignTo;
      
      const isNewAssigneeAdded = isNewAssigneeFirstTime || isNewAssigneeChanged;
      if (isNewAssigneeAdded) {
        newlyAddedAssigneeActions.push(fiveWhy);
      }
      
      // Set the flags for each action to be sent to backend
      fiveWhy.isNewlyCompleted = isNewlyCompleted;
      fiveWhy.isNewlyClosed = isNewlyClosed;
      fiveWhy.isNewlyRejected = isNewlyRejected;
      fiveWhy.isNewlyReassigned = isNewAssigneeAdded; // Covers both first-time and changed assignments
      
      // Update state tracking properties
      fiveWhy.hasCompletedActions = Boolean(fiveWhy.ID && fiveWhy.ActionCompleted === 'Yes');
      fiveWhy.hasClosedActions = Boolean(fiveWhy.ID && fiveWhy.Status === 'Closed');
      fiveWhy.hasRejectedActions = Boolean(fiveWhy.ID && fiveWhy.Verification === 'Rejected');
      fiveWhy.hasNewAssigneeAdded = Boolean(fiveWhy.ID && fiveWhy.NewAssignee);
      
       fiveWhy.CreatedBy = fiveWhy.CreatedBy ? fiveWhy.CreatedBy : this.user.userCode;
      
      
      if (this.levelId == 0 || this.levelId == 5) {
        delete fiveWhy.MainRowShow;
        fiveWhy.FyActionId = fiveWhy.fiveWhyId;
        fiveWhy.fiveWhyId = null;
      }
      fiveWhy.AssignTo = fiveWhy.AssignTo == '' ? null : fiveWhy.AssignTo;
      fiveWhy.PriorityLevel = fiveWhy.PriorityLevel ? fiveWhy.PriorityLevel : 1;
      fiveWhy.NewAssignee =
        fiveWhy.NewAssignee == '' ? null : fiveWhy.NewAssignee;
      fiveWhy.VerifiedBy =
        fiveWhy.VerificationBy == '' ? null : fiveWhy.VerificationBy;
      fiveWhy.ActionCompletedBy =
        fiveWhy.ActionCompletedBy == '' ? null : fiveWhy.ActionCompletedBy;
      fiveWhy.VerificationBy =
        fiveWhy.VerificationBy == '' ? null : fiveWhy.VerificationBy;

      if (fiveWhy.TargetDate) {
        fiveWhy.TargetDate = new Date(fiveWhy.TargetDate);
        fiveWhy.TargetDate.setHours(new Date().getHours());
        fiveWhy.TargetDate.setMinutes(new Date().getMinutes());
        fiveWhy.TargetDate.setSeconds(new Date().getSeconds());
      }
      if (fiveWhy.AssignedDate) {
        fiveWhy.AssignedDate = new Date(fiveWhy.AssignedDate);
        fiveWhy.AssignedDate.setHours(new Date().getHours());
        fiveWhy.AssignedDate.setMinutes(new Date().getMinutes());
        fiveWhy.AssignedDate.setSeconds(new Date().getSeconds());
      }
      if (fiveWhy.RevisedDate) {
        fiveWhy.RevisedDate = new Date(fiveWhy.RevisedDate);
        fiveWhy.RevisedDate.setHours(new Date().getHours());
        fiveWhy.RevisedDate.setMinutes(new Date().getMinutes());
        fiveWhy.RevisedDate.setSeconds(new Date().getSeconds());
      }
      if (fiveWhy.ClosedDate) {
        fiveWhy.ClosedDate = new Date(fiveWhy.ClosedDate);
        fiveWhy.ClosedDate.setHours(new Date().getHours());
        fiveWhy.ClosedDate.setMinutes(new Date().getMinutes());
        fiveWhy.ClosedDate.setSeconds(new Date().getSeconds());
      }

      fiveWhy.Status =
        fiveWhy.TargetDate && !fiveWhy.RevisedDate
          ? 'InProgress'
          : fiveWhy.TargetDate && fiveWhy.RevisedDate
          ? 'Delayed'
          : 'Open';
      if (fiveWhy.ActionCompleted == 'Yes') {
        fiveWhy.Status = 'Complete';
      }
      if (fiveWhy.Verification == 'Approved') {
        fiveWhy.Status = 'Closed';
        fiveWhy.ClosedDate = new Date();
      } else if (fiveWhy.Verification == 'Disapproved') {
        fiveWhy.Status = 'ReOpened';
        fiveWhy.ActionCompleted = 'No';
      }

      if (fiveWhy.Status != 'Closed') statusCheck = true;
    }

    const closecheck = this.orgfiveWhy.some((el: any) => el.Status != 'Closed');
    if (closecheck) statusCheck = true;

    if (event?.StatusFiveWhy && event?.StatusFiveWhy == 'InProgress') {
      let found: any;
      if (this.levelId == 0 || this.levelId == 5)
        found = this.orgfiveWhy.some(
          (el: any) =>
            el.RootCause ||
            el.Action ||
            el.AssignTo ||
            el.TargetDate ||
            el.Verification
        );
      else
        found = this.orgfiveWhy.some(
          (el: any) =>
            el.Action || el.AssignTo || el.TargetDate || el.Verification
        );

      if (!found) event.StatusFiveWhyAction = 'Open';
      else event.StatusFiveWhyAction = 'InProgress';
    } else {
      // const found = this.orgfiveWhy.some((el: any) => el.Action || el.AssignTo || el.TargetDate || el.Verification);

      let found: any;
      if (this.levelId == 0 || this.levelId == 5)
        found = this.orgfiveWhy.some(
          (el: any) =>
            el.RootCause ||
            el.Action ||
            el.AssignTo ||
            el.TargetDate ||
            el.Verification
        );
      else
        found = this.orgfiveWhy.some(
          (el: any) =>
            el.Action || el.AssignTo || el.TargetDate || el.Verification
        );

      if (!found) event.StatusFiveWhyAction = 'Open';
      else if (statusCheck) event.StatusFiveWhyAction = 'InProgress';
      else if (!statusCheck) event.StatusFiveWhyAction = 'Completed';
    }

    if (statusCheck) {
      let completeArr = this.orgfiveWhy.filter(
        (el: any) => el.Status != 'Closed'
      );
      const completecheck = completeArr.every(
        (el: any) => el.Status == 'Complete'
      );
      if (completecheck) {
        if (event.StatusFiveWhy == 'Completed') event.StatusCycle = 'NotClosed';
        else event.StatusCycle = 'InProgress';
      } else event.StatusCycle = 'InProgress';
    }

    const delaycheck = this.orgfiveWhy.some(
      (el: any) => el.Status == 'Delayed' || el.Status == 'ReOpened'
    );
    if (delaycheck) event.StatusCycle = 'Delayed';

    // let FiveWhy = {
    //   headerId: this.headerData.ID,
    //   createdBy: this.user.userCode,
    //   data: this.fiveWhy
    // };
    delete event.fiveWhy;
    delete event.causeAndEffects;
    delete event.fiveWhyActionPlan;
    delete event.updateStatus;
    delete event.hasRca;
    delete event.uniqueCode;
    // event.StatusFiveWhyAction = event.StatusFiveWhy && event.StatusFiveWhy == 'InProgress' ? 'InProgress' : statusCheck ? 'InProgress' : 'Completed';
    let iCount = 0;
    event.stageId = this.levelId ? this.levelId : this.stageId;
    const formData = new FormData();
    for (const file of this.fiveWhy) {
      if (file.UploadFile && typeof file.UploadFile === 'object') {
        formData.append('UploadFile', file.UploadFile);
        file.UploadFile = true;
        iCount++;
      }
      if (file.UploadDoc && typeof file.UploadDoc === 'object') {
        formData.append('UploadFile', file.UploadDoc);
        file.UploadDoc = true;
        iCount++;
      }
    }
    event.FyActionFileCount = iCount;
    event.CreatedBy = this.user.userCode;

    // Extract assignees from "Complete" transition for notifications
    // Only include newly completed actions for notifications
    const completeTransition = this.transitions.find(
      (t: any) => t.actionName === 'Complete'
    );
    event.Assignees = completeTransition?.assignees?.join(',') || ''; 
    
    // Only set assignees if there are newly completed actions
    if (newlyCompletedActions.length > 0) {
  
      event.NewlyCompletedActionsCount = newlyCompletedActions.length;
    } else {
      event.NewlyCompletedActionsCount = 0;
    }
    
    // Track newly closed actions count
    if (newlyClosedActions.length > 0) {
      event.NewlyClosedActionsCount = newlyClosedActions.length;
    } else {
      event.NewlyClosedActionsCount = 0;
    }
    
    // Track newly rejected actions count
    if (newlyRejectedActions.length > 0) {
      event.NewlyRejectedActionsCount = newlyRejectedActions.length;
    } else {
      event.NewlyRejectedActionsCount = 0;
    }
    
    // Track newly added assignee actions count
    if (newlyAddedAssigneeActions.length > 0) {
      event.NewlyReassignedActionsCount = newlyAddedAssigneeActions.length;
    } else {
      event.NewlyReassignedActionsCount = 0;
    }
    
    formData.append('UploadFile', event.UploadFile);
    formData.append('header', JSON.stringify(event));
    formData.append('data', JSON.stringify(this.fiveWhy));
    formData.append('createdBy', JSON.stringify(this.user.userCode));

    let route = this.router.url;
    if (!route.includes('at/at-stages')) {
      formData.append('integrationData', JSON.stringify(integrationData));
    }

    if (this.IndividualFivewhyID)
      formData.append(
        'individualFivewhyID',
        JSON.stringify(this.IndividualFivewhyID)
      );
    this.spinnerText = 'Saving Five Why Plan Data';
    this.spinner.show();
    if (this.updateStatus) {
      this.FivewhyService.updateFiveWhyPlanData(formData).pipe(takeUntil(this.destroy$)).subscribe(
        (res: any) => {
          if (!res.status) {
            this.toaster.error('Error', res.message);
            this.getFiveWhyActionPlan('');
            this.spinner.hide();
            return;
          }
          this.callSaveMethod = true;
          this.analyticalToolsService.setHeaderId(res.data.headerId);
          this.analyticalToolsService.setStatus(this.updateStatus);
          this.analyticalToolsService.setRcaId(res.data.rcaId);
          this.toaster.success('Success', res.message);
          this.headerData.ID = res.data.headerId;
          this._emitHeaderData.emit(res.data);
          this.onSuccess.emit('actionPlan');

          this.getFiveWhyActionPlan('');
          this.getWorkFlowTransitions();
          this.spinner.hide();
          // this.router.navigate(['/at/fivewhy']);
        },
        (error: any) => {
          this.spinner.hide();
          this.toaster.error('Error', error.ErrorMessage);
        }
      );
    } else {
      this.FivewhyService.addFiveWhyActionData(formData).pipe(takeUntil(this.destroy$)).subscribe(
        (res: any) => {
            if (!res.status) {
            this.toaster.error('Error', res.message);
            this.getFiveWhyActionPlan('');
            this.formData.verifiedBy = 'No';
            this.spinner.hide();
            return;
          }
          this.callSaveMethod = true;
          this.analyticalToolsService.setHeaderId(res.data.headerId);
          this._emitHeaderData.emit(res.data);
          this.updateStatus = true;
          this.onSuccess.emit('actionPlan');
          this.analyticalToolsService.setStatus(this.updateStatus);
          this.analyticalToolsService.setRcaId(res.data.rcaId);
          this.toaster.success('Success', res.message);
          this.headerData.ID = res.data.headerId;
          console.log(this.headerData);
          this.analyticalToolsService.searchHeader;
          this.getFiveWhyActionPlan('');
          this.getWorkFlowTransitions();
          // this.router.navigate(['/at/fivewhy']);
          this.spinner.hide();
        },
        (error: any) => {
          this.spinner.hide();
          this.toaster.error('Error', error.ErrorMessage);
        }
      );
    }
  }

  statusChange(data: any) {
    if (data.Status == 'Closed') {
      if (!data.Action) {
        this.toaster.warning(
          'Warning',
          `You Can't Close Status Until Action Field Value Is Empty`
        );
        setTimeout(() => {
          data.Status = 'Open';
        }, 250);
        return;
      } else if (!data.ActionType) {
        this.toaster.warning(
          'Warning',
          `You Can't Close Status Until ActionType Field Value Is Empty`
        );
        setTimeout(() => {
          data.Status = 'Open';
        }, 250);
        return;
      } else if (!data.AssignTo) {
        this.toaster.warning(
          'Warning',
          `You Can't Close Status Until AssignTo Field Value Is Empty`
        );
        setTimeout(() => {
          data.Status = 'Open';
        }, 250);
        return;
      } else if (!data.AssignedDate) {
        this.toaster.warning(
          'Warning',
          `You Can't Close Status Until AssignedDate Field Value Is Empty`
        );
        setTimeout(() => {
          data.Status = 'Open';
        }, 250);
        return;
      } else if (!data.TargetDate) {
        this.toaster.warning(
          'Warning',
          `You Can't Close Status Until TargetDate Field Value Is Empty`
        );
        setTimeout(() => {
          data.Status = 'Open';
        }, 250);
        return;
      } else if (!data.RevisedDate) {
        this.toaster.warning(
          'Warning',
          `You Can't Close Status Until RevisedDate Field Value Is Empty`
        );
        setTimeout(() => {
          data.Status = 'Open';
        }, 250);
        return;
      } else if (!data.ClosedDate) {
        this.toaster.warning(
          'Warning',
          `You Can't Close Status Until ClosedDate Field Value Is Empty`
        );
        setTimeout(() => {
          data.Status = 'Open';
        }, 250);
        return;
      } else if (!data.VerifiedBy) {
        this.toaster.warning(
          'Warning',
          `You Can't Close Status Until VerifiedBy Field Value Is Empty`
        );
        setTimeout(() => {
          data.Status = 'Open';
        }, 250);
        return;
      }
    }
  }

  openFile(i: any, type: any) {
    if (type == 'pic') this.fileInput.nativeElement.click();
    else this.fileInputFile.nativeElement.click();
    this.ind = i;
  }

  readFile(event: any, type: any) {
    this.imageFile = event.target.files[0];
    // this.fiveWhy[this.ind].UploadFile = this.imageFile;
    // this.fiveWhy[this.ind].Index = this.ind
    // this.UploadFile[this.ind].File = this.imageFile;
    // this.UploadFile[this.ind].Index = this.ind
    // this.imageFile.encoding = this.ind
    // this.UploadFile.push(this.imageFile);
    if (type == 'pic') {
      this.isAnyFileUploaded = true;
      this.fiveWhy[this.ind].UploadFile = this.imageFile;
    } else this.fiveWhy[this.ind].UploadDoc = this.imageFile;
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSrc = reader.result as string;
        if (type == 'pic') this.fiveWhy[this.ind].FileSrc = this.imageSrc;
        else {
          this.isAnyFileUploaded = true;
          this.fiveWhy[this.ind].DocSrc = this.imageSrc;
          this.fiveWhy[this.ind].base64 =
            this.domSanitizer.bypassSecurityTrustUrl(reader.result as string);
        }
      };
    }
  }

  deleteFile(i: any, type: any) {
    if (type == 'pic') {
      this.fiveWhy[i].FileSrc = '';
      this.fiveWhy[i].UploadFile = '__DELETE__';
    } else {
      this.fiveWhy[i].DocSrc = '';
      this.fiveWhy[i].UploadDoc = '__DELETE__';
      this.fiveWhy[i].base64 = '';
    }
    // this.fiveWhy[this.ind].UploadFile = '';
  }

  imageZoomModal(i: any): void {
    let imgLink: any;
    // if (this.isAnyFileUploaded) {
    //   imgLink = this.imageSrc;
    // } else {
    //   imgLink = this.blobStorageUrl + this.fiveWhy[i].UploadFile;
    // }
    // if (this.imageSrc) {
    //   imgLink = this.fiveWhy[i].FileSrc;
    // } else {
    //   imgLink = this.blobStorageUrl + this.fiveWhy[i].UploadFile;
    // }
    if (this.fiveWhy[i]?.FileSrc) {
      imgLink = this.fiveWhy[i].FileSrc;
    } else {
      imgLink = this.blobStorageUrl + this.fiveWhy[i].UploadFile;
    }
    let dialogRef = this.dialog.open(ImageDialogComponent, {
      height: '90%',
      width: '75%',
      data: imgLink,
    });
  }

  getMinDate(row: any, type: any) {
    if (type == 'Revised') {
      const date = row.RevisedDate ? row.RevisedDate : row.TargetDate;
      let currentDate = new Date(date);
      // return new Date(currentDate.setDate(currentDate.getDate() + 1))

      let minDateStartFrom = new Date(
        currentDate.setDate(currentDate.getDate() + 1)
      );

      row.MinRevisedDate = (current: Date): boolean =>
        // Can not select days before today and today
        differenceInCalendarDays(current, minDateStartFrom) < 0;
      return row.MinRevisedDate;
    } else if (type == 'Target') {
      let currentDate = new Date();
      // return new Date(currentDate.setDate(currentDate.getDate() + 1))

      let minDateStartFrom = new Date(
        currentDate.setDate(currentDate.getDate())
      );

      row.MinTargetDate = (current: Date): boolean =>
        // Can not select days before today and today
        differenceInCalendarDays(current, minDateStartFrom) < 0;
      return row.MinTargetDate;
    }
  }
  downloadPDF(i, fiveWhy) {
    // [href]=" yData.DocSrc || blobStorageUrl + yData.UploadDoc"
    if (fiveWhy.base64) {
      const base64 = fiveWhy.base64;
      var a = document.createElement('a'); //Create <a>
      a.href = base64?.changingThisBreaksApplicationSecurity; //Image Base64 Goes here
      a.download = 'file.pdf'; //File name Here
      a.click();
    } else {
      const base64 = fiveWhy.DocSrc;
      var a = document.createElement('a'); //Create <a>
      a.href = this.blobStorageUrl + fiveWhy.UploadDoc; //Image Base64 Goes here
      a.download = 'file.pdf';
      a.target = '_blank'; //File name Here
      a.click();
    }
  }

  isAssigneeDisabled(yData: any): boolean {

  // 1. Status is Closed
  if (yData?.Status === 'Closed') {
    return true;
  }

  // 2. Action is not empty
  if (yData?.Action === '') {
    return true;
  }

  // 3. AssignedDate exists AND LoggedInUser is NOT creator
  if (
    yData?.IsLoggedInUserCreator === false
  ) {
    return true;
  }

  // 4. ActionCompletedOn is not empty
 if (
  yData?.ActionCompletedOn !== '' &&
  yData?.ActionCompletedOn !== null &&
  yData?.ActionCompletedOn !== undefined
) {
  return true;
}

  return false;
}



  isNewAssigneeDisabled(yData: any): boolean {

  // 1. Status is Closed
  if (yData?.Status === 'Closed') {
    return true;
  }

  // 2. Action is not empty
  if (yData.Verification != 'Disapproved') {
    return true;
  }

  // 3. AssignedDate exists AND LoggedInUser is NOT creator
  if (
    yData?.IsLoggedInUserCreator === false
  ) {
    return true;
  }

  // 4. ActionCompletedOn is not empty
 if (
  yData?.ActionCompletedOn !== '' &&
  yData?.ActionCompletedOn !== null &&
  yData?.ActionCompletedOn !== undefined &&
  yData?.ActionCompleted == ''
) {
  return true;
}

  return false;
}

  setAssignDate(row: any) {
    row.AssignedDate = new Date();
    this.updateRowAssignmentFlags(row);
    // Logic based on assignee, creator, and logged-in user
    // Case 1: Assignee = Creator AND Assignee = Logged-in user → Enable all steps
    if (row.IsAssignedToCreator && row.IsAssignedToCurrentUser) {
      // All steps are enabled (no restrictions)
      return;
    }
    
    // Case 2: Assignee = Creator but NOT logged-in user → Don't enable ActionCompleted
    if (row.IsAssignedToCreator && row.IsAssignedToCurrentUser == false) {
      row.ActionCompleted = 'No';
      row.ActionCompletedBy = '';
      row.ActionCompletedOn = '';
      row.Verification = '';
      row.VerificationBy = '';
      row.VerificationOn = '';
      return;
    }
    
    // Case 3: Assignee ≠ Creator but Assignee = Logged-in user → Only enable ActionCompleted
    if (row.IsAssignedToCreator == false && row.IsAssignedToCurrentUser) {
      // ActionCompleted is enabled, but Verification should be disabled for this user
      // Reset verification fields since this user is not the creator
      row.Verification = '';
      row.VerificationBy = '';
      row.VerificationOn = '';
      return;
    }
    
    // Default case: Reset all fields if none of the above conditions match
    row.ActionCompleted = 'No';
    row.ActionCompletedBy = '';
    row.ActionCompletedOn = '';
    row.Verification = '';
    row.VerificationBy = '';
    row.VerificationOn = '';
  }

updateRowAssignmentFlags(row: any): void {
  if (!row) {
    return;
  }

  // Use NewAssignee if available, otherwise fall back to AssignTo
  const effectiveAssignee =
    row.NewAssignee != null && row.NewAssignee !== ''
      ? row.NewAssignee
      : row.AssignTo;

  row.IsAssignedToCreator =
    effectiveAssignee == null || row.CreatedBy == null
      ? undefined
      : effectiveAssignee === row.CreatedBy;

  row.IsAssignedToCurrentUser =
    effectiveAssignee == null || this.user?.userCode == null
      ? undefined
      : effectiveAssignee === this.user.userCode;

  row.IsLoggedInUserCreator =
    this.user?.userCode == null || row.CreatedBy == null
      ? undefined
      : this.user.userCode === row.CreatedBy;
}

  updateAllRowsAssignmentFlags() {
    if (this.fiveWhy && this.fiveWhy.length) {
      this.fiveWhy.forEach((row: any) => {
        this.updateRowAssignmentFlags(row);
      });
    }
  }

  onRevisedDateChange(row: any) {
    if (row.MissesCondition) {
      row.NoOfMisses++;
      row.MissesCondition = false;
    } else if (!row.MissesCondition && !row.RevisedDate) {
      row.NoOfMisses--;
      row.MissesCondition = true;
    }
    // row.MinRevisedDate = (current: Date): boolean =>
    // // Can not select days before today and today
    // differenceInCalendarDays(current, new Date(row.TargetDate)) < 0;
  }

  ActionCompletedChange(row: any) {
    this.updateRowAssignmentFlags(row);
    if (row.ActionCompleted == 'Yes') {
      row.ActionCompletedBy = this.user.userCode;
      row.ActionCompletedOn = new Date();
      // Only clear Verification, don't allow non-creators to set it
      // Verification should only be accessible if assignee is the creator
      if (row.IsAssignedToCreator == false) {
        row.Verification = '';
        row.VerificationBy = '';
        row.VerificationOn = null;
      } else {
        row.Verification = '';
      }
    } else {
      row.ActionCompletedBy = '';
      row.ActionCompletedOn = null;
      row.Verification = '';
      row.VerificationBy = '';
      row.VerificationOn = null;
    }
  }

  onDatePickerOpen(isOpen: boolean): void {
    if (isOpen) {
      this.setDatePickerZindex();
    }
  }

  setDatePickerZindex(): void {
    const overlayContainers = document.querySelectorAll(
      '.cdk-overlay-container'
    );

    overlayContainers.forEach((container) => {
      const hasDialogInside =
        container.querySelector('mat-dialog-container') !== null;

      if (!hasDialogInside) {
        (container as HTMLElement).style.setProperty(
          'z-index',
          '9999',
          'important'
        );
      }
    });
  }

  VerificationChange(row: any) {
    // if (row.Verification == 'Approved') {
    row.VerificationBy = this.user.userCode;
    row.VerificationOn = new Date();
    // }
    // else if (row.Verification == 'Disapproved') {
    //   row.VerificationBy = '';
    //   row.VerificationOn = null;
    // }
    
    // Clear remarks requirement flag when verification changes
    if (row.Verification !== 'Disapproved') {
      row.remarksRequired = false;
    } else {
      row.remarksRequired = true;
    }
  }
  ngOnDestroy() {
    this.spinner.hide();
    if (this.sub) this.sub.unsubscribe();
  }
  getMClassificationList() {
    this.actionplanService.getMClassification().pipe(takeUntil(this.destroy$)).subscribe(
      (response) => {
        this.mClassificationTypes = response;
      },
      (error) => {
        this.toaster.error('Error', 'Something Went Wrong');
      }
    );
  }

  getWorkFlowTransitions() {
    const screenName = 'NCR';
    this.transitions = [];
        const key = {
          screenName,
          tenantId: this.plantData.plantCode,
          companyKey: Constants.COMPANY_KEY,
        };
    this.flowService.getWorkFlow(key).pipe(takeUntil(this.destroy$)).subscribe(
      (res: any) => {
        if (res) {
          this.ncrWorkFlow = res;
          const workFlowKey = this.ncrWorkFlow?.workFlowKey;
          
          this.flowService.getWorkflowStatuses(workFlowKey).pipe(takeUntil(this.destroy$)).subscribe(
            (response: any) => {
              if (response && response.length > 0) {
                this.transitions = response;
                console.log('Transitions loaded:', this.transitions);
              }
            },
            (error) => {
              console.error('Error loading transitions:', error);
            }
          );
        }
      },
      (error) => {
        console.error('Error loading workflow:', error);
      }
    );
  }

  // Table headers come from a column-name array, so they are translated here rather
  // than in the template. Falls back to the English name when no tag is configured.
  public translateColumn(name: string): string {
    if (!name) {
      return '';
    }
    const tag = String(name)
      .split(/[^A-Za-z0-9]+/)
      .filter((word) => !!word)
      .map((word) => (word === word.toUpperCase() ? word : word.charAt(0).toUpperCase() + word.slice(1)))
      .join('');
    if (!tag || !this.translate) {
      return name;
    }
    const translated = this.translate.instant(tag);
    return translated && translated !== tag ? translated : name;
  }
}
